import React from 'react';

import { useProxyUrl } from '../Document.hook';
import PDFViewer from './PDFViewer';
import MSOfficeLiveViewer from './MSOfficeLiveViewer';
import CSVViewer from './CSVViewer';
import UnrenderedFilesViewer from './UnrenderedFilesViewer';
import { parseFilePath, FILE_TYPES } from '../Document.helpers';
export interface DocumentViewerProps {
  title?: string;
  storageKey: string;
  fileSize?: number;
  className?: string;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({
  title,
  storageKey,
  fileSize,
  className
}) => {
  console.debug('storageKey', storageKey);
  const { ext } = parseFilePath(storageKey);
  console.debug('ext', ext);
  const extension = ext.replace('.', '');
  const url = useProxyUrl(storageKey, '', true).toString();
  console.debug('url', url);

  if (extension === 'pdf') {
    return <PDFViewer key={url} url={url} className={className} />;
  }
  if (FILE_TYPES.msoffice.includes(extension)) {
    return (
      <MSOfficeLiveViewer
        key={url}
        title={title || 'Document'}
        url={url || ''}
        className={className}
      />
    );
  }
  if (FILE_TYPES.images.includes(extension)) {
    return (
      <img key={url} src={url} width='100%' alt={title} className={className} />
    );
  }
  if (
    FILE_TYPES.text.includes(extension) ||
    FILE_TYPES.video.includes(extension) ||
    FILE_TYPES.audio.includes(extension)
  ) {
    return (
      <iframe
        key={url}
        title={title}
        src={url}
        className={className}
        width='100%'
        height='100%'
      />
    );
  }
  if (extension === 'csv') {
    return <CSVViewer fileUrl={url} className={className} />;
  }
  return (
    <UnrenderedFilesViewer
      fileName={title + '.' + extension}
      fileSize={fileSize}
      className={className}
    />
  );
};

export default DocumentViewer;
